module.exports = __webpack_public_path__ + "img/rku10.16e49552.png";